/**
 * @desc 修改供应商账号
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierAccountRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
